import DataTable from "react-data-table-component";
import { tableStyles } from "../../../TableStyle";

const toNumber = (v) => (isFinite(Number(v)) ? Number(v) : 0);
const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const KiosksTable = ({ t, data, onRowClicked }) => {
  const columnsBornes = [
    { name: t("kiosk_name"), selector: (row) => row.kiosk_name, sortable: true },
    {
      name: t("amount_raised"),
      selector: (row) => toNumber(row.amount_collected),
      cell: (row) => `${formatCurrency(row.amount_collected)} $`,
      sortable: true,
      right: true,
    },
    {
      name: `${t("amount_raised")} (%)`,
      selector: (row) => toNumber(row.montant_recolte_percent),
      cell: (row) => `${toNumber(row.montant_recolte_percent).toFixed(2)}%`,
      sortable: true,
      right: true,
    },
    {
      name: t("number_of_transactions"),
      selector: (row) => toNumber(row.number_of_transactions),
      sortable: true,
      right: true,
    },
    {
      name: `${t("number_of_transactions")} (%)`,
      selector: (row) => toNumber(row.nombre_transaction_percent),
      cell: (row) => `${toNumber(row.nombre_transaction_percent).toFixed(2)}%`,
      sortable: true,
      right: true,
    },
  ];

  return (
    <div className="flex flex-1 flex-col">
      <div style={{ fontSize: 20 }}>{t("kiosk_details")}</div>
      <DataTable
        highlightOnHover
        customStyles={tableStyles}
        columns={columnsBornes}
        data={data}
        pagination
        pointerOnHover
        onRowClicked={onRowClicked}
      />
    </div>
  );
};

export default KiosksTable;
